import i18n from '@/plugins/i18n';

const serviceGraphs = () => ({
  lineCharts: [
    {
      width: '18%',
      widthInPer: '100%',

      title: i18n.global.t('serviceApdex'),
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_apdex',
      queryMetricType: 'readMetricsValue',
      chartType: 'ChartGauge',
      enabled: false,
      aggregation: '/',
      aggregationNum: '10000',
      colorEncoder: true,
      good: ['0.84', '1.00'],
      fair: ['0.69', '0.83'],
      poor: ['0.00', '0.68'],
      formatValue: (val) => val / 100,
      showApdexInfo: true,
    },
  ],
  slowTraces: [
    {
      width: 3,
      parentWidth: '57.5%',
      title: i18n.global.t('endpoint-by-error'),
      icon: 'error',
      height: '12.5em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'endpoint_error_percent',
      queryMetricType: 'sortMetrics',
      chartType: 'ChartSlow',
      aggregation: '/',
      aggregationNum: '100',
      parentService: true,
      unit: '%',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '%',
      },
    },
    {
      width: '4',
      title: i18n.global.t('instances-by-error'),
      icon: 'error',
      height: '17.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_instance_error_percent',
      queryMetricType: 'sortMetrics',
      chartType: 'ChartSlow',
      parentService: true,
      unit: '%',
      aggregation: '/',
      aggregationNum: '100',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '%',
      },
    },
    {
      width: '3',
      title: i18n.global.t('endpoints-by-response-time-ms'),
      icon: 'responseTime',
      height: '17.5em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      queryMetricType: 'sortMetrics',
      chartType: 'ChartSlow',
      metricName: 'endpoint_avg',
      unit: 'ms',
      parentService: true,
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      compareTrend: true,
    },
    {
      width: '4',
      title: i18n.global.t('instances-by-response-time-ms'),
      icon: 'responseTime',
      height: '17.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_instance_resp_time',
      queryMetricType: 'sortMetrics',
      chartType: 'ChartSlow',
      parentService: true,
      unit: 'ms',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      compareTrend: true,
    },
  ],
  areaCharts: [
    {
      width: 3,
      widthInPer: '100%',
      title: i18n.global.t('apm.service-percentile-response-time'),
      height: '12.5em',
      header: {
        title: i18n.global.t('percentileResponseTimeTitle'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#5CA8FF', '#0DCEBF', '#FFCC55', '#A0A7E6', '#EA7699'],

      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_percentile',
      queryMetricType: 'readLabeledMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'ms',
      metricLabels: 'P50, P75, P90, P95, P99',
      labelsIndex: '0, 1, 2, 3, 4',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentileUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
  forecastDisabledLineCharts: [
    {
      width: '39.5%',
      title: i18n.global.t('bm.service-load'),
      header: {
        title: i18n.global.t('loadTitle'),
        titleIcon: '',
        subIconTitle: 'starFilled',
        content: [],
      },
      chartColor: ['#008FFB'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_total_call',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'service_cpm',
        //   queryMetricType: 'readMetricsTotalValue',
        //   name: 'total'
        //   // aggregation: '/',
        //   // aggregationNum: '10000'
        // },
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'service_cpm',
        //   queryMetricType: 'readMetricsValue',
        //   name: 'pm'
        //   // aggregation: '/',
        //   // aggregationNum: '10000'
        // }
      ],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '39.5%',
      title: i18n.global.t('errorTitle'),
      header: {
        title: i18n.global.t('errorTitle'),
        titleIcon: 'error',
        subIconTitle: 'starFilled',
        content: [],
        isError: true,
      },

      chartColor: ['#d3799a', '#66cc98'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'service_error_code__4xx_percent,service_error_code__5xx_percent',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'Service',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_error_count',
          queryMetricType: 'readMetricsValue',
          name: 'total',
        },

        {
          entityType: 'Service',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_error_code__4xx_percent',
          queryMetricType: 'readMetricsValue',
          name: 'percentage',
        },
        {
          entityType: 'Service',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_error_code__5xx_percent',
          queryMetricType: 'readMetricsValue',
          name: 'percentage',
        },
        {
          entityType: 'Service',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_epm',
          queryMetricType: 'readMetricsValue',
          name: 'pm',
        },
      ],
      chartType: 'ApexChartArea',
      isMultiLineSeriesTooltip: true,
      unit: 'No',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('errorPercentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      width: '40%',
      title: i18n.global.t('apm.service-avg-response-time'),
      header: {
        title: i18n.global.t('responseTimeWithoutUnit'),
        titleIcon: 'responseTime',
        subIconTitle: 'starFilled',
        content: [],
        displayOnlyUnit: true,
      },
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_resp_time',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          // entityType: 'Service',
          // independentSelector: false,
          // metricType: 'REGULAR_VALUE',
          // metricName: 'service_resp_time',
          // queryMetricType: 'readMetricsValue',
          // name: 'total'
        },
      ],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('ms-average'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('responseTimeWithUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
});
export default serviceGraphs;
